import { MapLocation } from '../types';

export const locations: MapLocation[] = [
  {
    id: 'usa',
    name: 'United States',
    coordinates: [250, 150],
    stats: {
      universities: 450,
      students: 85000,
      courses: 1200,
      jobs: 3500
    }
  },
  {
    id: 'uk',
    name: 'United Kingdom',
    coordinates: [450, 120],
    stats: {
      universities: 150,
      students: 45000,
      courses: 800,
      jobs: 2200
    }
  },
  {
    id: 'canada',
    name: 'Canada',
    coordinates: [220, 100],
    stats: {
      universities: 100,
      students: 32000,
      courses: 500,
      jobs: 1500
    }
  },
  {
    id: 'australia',
    name: 'Australia',
    coordinates: [740, 350],
    stats: {
      universities: 120,
      students: 38000,
      courses: 600,
      jobs: 1800
    }
  },
  {
    id: 'newzealand',
    name: 'New Zealand',
    coordinates: [800, 380],
    stats: {
      universities: 40,
      students: 15000,
      courses: 300,
      jobs: 800
    }
  },
  {
    id: 'india',
    name: 'India',
    coordinates: [680, 220],
    stats: {
      universities: 900,
      students: 120000,
      courses: 1500,
      jobs: 4500
    }
  },
  {
    id: 'uae',
    name: 'United Arab Emirates',
    coordinates: [600, 200],
    stats: {
      universities: 60,
      students: 25000,
      courses: 400,
      jobs: 1200
    }
  },
  // New European Countries
  {
    id: 'france',
    name: 'France',
    coordinates: [460, 140],
    stats: {
      universities: 150,
      students: 35000,
      courses: 600,
      jobs: 1800
    }
  },
  {
    id: 'germany',
    name: 'Germany',
    coordinates: [480, 130],
    stats: {
      universities: 200,
      students: 40000,
      courses: 700,
      jobs: 2000
    }
  },
  {
    id: 'italy',
    name: 'Italy',
    coordinates: [490, 160],
    stats: {
      universities: 90,
      students: 30000,
      courses: 500,
      jobs: 1500
    }
  },
  {
    id: 'spain',
    name: 'Spain',
    coordinates: [440, 170],
    stats: {
      universities: 80,
      students: 28000,
      courses: 450,
      jobs: 1400
    }
  },
  // Central Asian Countries
  {
    id: 'uzbekistan',
    name: 'Uzbekistan',
    coordinates: [620, 160],
    stats: {
      universities: 65,
      students: 18000,
      courses: 250,
      jobs: 800
    }
  },
  // South Asian Countries
  {
    id: 'nepal',
    name: 'Nepal',
    coordinates: [670, 200],
    stats: {
      universities: 45,
      students: 15000,
      courses: 200,
      jobs: 600
    }
  }
];